import { Account } from "./account";

export class AccountGroup {
    id: number;
    name: string;
    accounts: AccountsGroup[];

    constructor(name?: string) {
        this.id = 0;
        this.name = name ? name : null;
        this.accounts = [];
    }
}

export class AccountsGroup {
    id: number;
    accountGroupId: number;
    accountOneId: number;
    accountOne?: Account;
    accountTwoId?: number;
    accountTwo?: Account;
    effectiveDate?: string;
    expirationDate?: string;

    constructor(accountOne?: Account, accountTwo?: Account, accountGroupId?: number) {
        this.id = 0;
        this.accountGroupId = accountGroupId || 0;
        this.accountOne = accountOne || undefined;
        this.accountOneId = accountOne ? accountOne.id : 0;
        this.accountTwo = accountTwo || undefined;
        this.accountTwoId = accountTwo ? accountTwo.id : undefined;
        this.effectiveDate = undefined;
        this.expirationDate = undefined;
    }
}


// WEBPACK FOOTER //
// ./src/model/accountGroup.ts